import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let LayoutColumn = class LayoutColumn extends Vue {
  get style() {
    return [{
      'grid-area': `span 1 / span ${this.ratioVal} / auto / auto`
    }];
  }
};
LayoutColumn.componentName = 'LayoutColumn';
__decorate([Prop({
  default: 1
})], LayoutColumn.prototype, "ratioVal", void 0);
__decorate([Prop({
  default: false
})], LayoutColumn.prototype, "isFirst", void 0);
__decorate([Prop({
  default: false
})], LayoutColumn.prototype, "isLast", void 0);
LayoutColumn = __decorate([Component({
  name: 'LayoutColumn'
})], LayoutColumn);
export default LayoutColumn;